import { BaseApiManager } from "./baseApiManager"

export class AppApiManager extends BaseApiManager {
    constructor() {
        super()
    }
    addSubjects = async (subjects) => {
        try {
            await this.customAxios.post(`/subjects`, {
                subjects
            })
            return true
        } catch (e) {
            if (e?.response?.status !== 401 && e?.response?.code !== 'ERR_CANCELED') this.alertFailureMessage(e)
            return false
        }
    }

    getSubjectPage = async (pageNum, pageSize, searchQuery) => {
        try {
            const searchQueryStr = searchQuery ? `&searchQuery=${searchQuery}` : ''
            const response = await this.customAxios.get(`/subjects?pageNum=${pageNum}&pageSize=${pageSize}${searchQueryStr}`)
            
            return response.data
        } catch (e) {
            if (e?.response?.status !== 401 && e?.response?.code !== 'ERR_CANCELED') this.alertFailureMessage(e)
            return {
                subjects: [],
                requestedPage: 1,
                pages: 1,
            }
        }
    }

    getSubjects = async () => {
        try {
            const response = await this.customAxios.get(`/subjects`)
            
            return response.data.subjects
        } catch (e) {
            if (e?.response?.status !== 401 && e?.response?.code !== 'ERR_CANCELED') this.alertFailureMessage(e)
            return null
        }
    }

    getSchools = async () => {
        try {
            const response = await this.customAxios.get(`/schools`)

            return response.data.schools
        } catch (e) {
            if (e?.response?.status !== 401 && e?.response?.code !== 'ERR_CANCELED') this.alertFailureMessage(e)
            return []
        }
    }

    deleteSubject = async (subjectId) => {
        try {
            await this.customAxios.delete(`/subjects/${subjectId}`)

            return true
        } catch (e) {
            if (e?.response?.status !== 401 && e?.response?.code !== 'ERR_CANCELED') this.alertFailureMessage(e)
            return false
        }
    }

    addTemplate = async (templateData) => {
        try {
            await this.customAxios.post(`/templates`, {
                templateData,
            })
            return true
        } catch (e) {
            if (e?.response?.status !== 401 && e?.response?.code !== 'ERR_CANCELED') this.alertFailureMessage(e)
            return false
        }
    }

    getTemplates = async () => {
        try {
            const response = await this.customAxios.get(`/templates`)
            return response.data.templates
        } catch (e) {
            if (e?.response?.status !== 401 && e?.response?.code !== 'ERR_CANCELED') this.alertFailureMessage(e)
            return []
        }
    }

    deleteTemplate = async (id) => {
        try {
            await this.customAxios.delete(`/templates/${id}`)
            return true
        } catch (e) {
            if (e?.response?.status !== 401 && e?.response?.code !== 'ERR_CANCELED') this.alertFailureMessage(e)
            return false
        }
    }

    uploadFormResponse = async (template, educator, responses) => {
        try {
            await this.customAxios.post(`/formresponse`, {
                template,
                educator,
                responses,
            })
            return true
        } catch (e) {
            if (e?.response?.status !== 401 && e?.response?.code !== 'ERR_CANCELED') this.alertFailureMessage(e)
            return false
        }
    }

    downloadFormResponses = async (templateId) => {
        try {
            const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const response = await this.customAxios.get(`/formresponse/${templateId}?tz=${tz}`, {
                responseType: 'blob',
            })

            return window.URL.createObjectURL(new Blob([response.data]))
        } catch (e) {
            if (e?.response?.status !== 401 && e?.response?.code !== 'ERR_CANCELED') this.alertFailureMessage(e)
            return null
        }
    }

    getTemplateAnalytics = async (templateId, schoolSelection) => {
        try {
            const response = await this.customAxios.get(`/formanalytics/${templateId}`,
                {
                    params: {
                        school: schoolSelection,
                    },
                }
            )
             return response.data
        } catch(e) {
            if (e?.response?.status !== 401 && e?.response?.code !== 'ERR_CANCELED') this.alertFailureMessage(e)
            return false
        }
    }
}
